import React from 'react';
import Screener from 'views/scenes/caregiver_screening/CaregiverScreener';

const CaregiverScreener = (props) => {
  return (
    <Screener {...props}/>
  );
};

CaregiverScreener.propTypes = {
};

export default React.memo(CaregiverScreener);

